module Meevo.Plugins.AlertsManager {
    enum EWaitlistActionTypeEnum {
        Added = 1,
        Booked = 2
    }

    class WaitListAppointmentIsAddedConfig extends BaseConfigComponent implements ng.IComponentController {
        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ]

        public params: IParams;
        public data;

        public alertType = EWaitlistActionTypeEnum.Added;
        public alertTypes = EWaitlistActionTypeEnum;

        get dataForReview() {
            if (!this.alertType) return [];

            return this.alertType === EWaitlistActionTypeEnum.Added
                ? [this.$translate.instant('WHEN_AN_APPOINTMENT_IS_ADDED_TO_THE_WAITLIST')]
                : [this.$translate.instant('WHEN_AN_APPOINTMENT_IS_BOOKED_FROM_THE_WAITLIST')];
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: this.alertType
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: Object): void {
            this.alertType = alertJSON[this.data.configKey];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoWaitListAppointmentIsAddedConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/waitlist-appointment-is-added/waitlist-appointment-is-added.config.html',
            controller: WaitListAppointmentIsAddedConfig,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        })
}
